import React from "react";
// import PropTypes from "prop-types";
// import styles from "./styles/SendFeedbackPage.module.css";
import { Button, Container, Form } from "react-bootstrap";

const SendFeedbackPage = () => {
  return (
    <Container className="my-3">
      <h5> Send Feedback</h5>

      <Form>
        <Form.Control className="my-3" placeholder="Email Address" />
        <Form.Control
          as={"textarea"}
          rows={5}
          className="my-3"
          placeholder="Describe your issue"
        />
        <h6>Add Screenshots</h6>
        {/* <Form.File
          className="my-3"
          id="custom-file"
          label="Custom file input"
          custom
        /> */}
        <Button variant="danger">Send Feedback</Button>
      </Form>
    </Container>
  );
};

/* required: display name */
SendFeedbackPage.displayName = "SendFeedbackPage";

/* required: props types */
SendFeedbackPage.propTypes = {};

/* required: default props */
SendFeedbackPage.defaultProps = {};

export { SendFeedbackPage };
